import { render, staticRenderFns } from "./selectModule.vue?vue&type=template&id=0aa44018&"
import script from "./selectModule.vue?vue&type=script&lang=ts&"
export * from "./selectModule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports